import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'

import { isTranslationModeEnabled } from 'utils/common'
import { IS_PRODUCTION, THEME_NAME } from 'utils/helperConfig'

export const locales = {
    en: () => import('dayjs/locale/en'),
    ru: () => import('dayjs/locale/ru'),
    es: () => import('dayjs/locale/es'),
    it: () => import('dayjs/locale/it'),
    lt: () => import('dayjs/locale/lt'),
    de: () => import('dayjs/locale/de'),
    ar: () => import('dayjs/locale/ar'),
    zh: () => import('dayjs/locale/zh'),
    fr: () => import('dayjs/locale/fr'),
    ur: () => import('dayjs/locale/ur'),
    tr: () => import('dayjs/locale/tr'),
}

// Add supported languages
const languages = ['en', 'ru', 'es', 'it', 'lt', 'de', 'ar', 'zh', 'fr', 'ur', 'tr']

const JSON_PATH = (file, lang) => {
    try {
        try {
            return require(`./themes/${THEME_NAME}/locale/${lang}/${file}.json`)
        } catch {
            return require(`./themes/base/locale/${lang}/${file}.json`)
        }
    } catch {
        return null //Important - This is fallback - Don't delete
    }
}

const resources = {
    en: {
        override: JSON_PATH('override', 'en'),
        translations: JSON_PATH('translations', 'en'),
        keys: JSON_PATH('keys', 'en'),
        legal: JSON_PATH('legal', 'en'),
        forms: JSON_PATH('forms', 'en'),
    },
    ru: {
        override: JSON_PATH('override', 'ru'),
        translations: JSON_PATH('translations', 'ru'),
        keys: JSON_PATH('keys', 'ru'),
        legal: JSON_PATH('legal', 'ru'),
        forms: JSON_PATH('forms', 'ru'),
    },
    es: {
        override: JSON_PATH('override', 'es'),
        translations: JSON_PATH('translations', 'es'),
        keys: JSON_PATH('keys', 'es'),
        legal: JSON_PATH('legal', 'es'),
        forms: JSON_PATH('forms', 'es'),
    },
    it: {
        override: JSON_PATH('override', 'it'),
        translations: JSON_PATH('translations', 'it'),
        keys: JSON_PATH('keys', 'it'),
        legal: JSON_PATH('legal', 'it'),
        forms: JSON_PATH('forms', 'it'),
    },
    lt: {
        override: JSON_PATH('override', 'lt'),
        translations: JSON_PATH('translations', 'lt'),
        keys: JSON_PATH('keys', 'lt'),
        legal: JSON_PATH('legal', 'lt'),
        forms: JSON_PATH('forms', 'lt'),
    },
    de: {
        override: JSON_PATH('override', 'de'),
        translations: JSON_PATH('translations', 'de'),
        keys: JSON_PATH('keys', 'de'),
        legal: JSON_PATH('legal', 'de'),
        forms: JSON_PATH('forms', 'de'),
    },
    ar: {
        override: JSON_PATH('override', 'ar'),
        translations: JSON_PATH('translations', 'ar'),
        keys: JSON_PATH('keys', 'ar'),
        legal: JSON_PATH('legal', 'ar'),
        forms: JSON_PATH('forms', 'ar'),
    },
    zh: {
        override: JSON_PATH('override', 'zh'),
        translations: JSON_PATH('translations', 'zh'),
        keys: JSON_PATH('keys', 'zh'),
        legal: JSON_PATH('legal', 'zh'),
        forms: JSON_PATH('forms', 'zh'),
    },
    fr: {
        override: JSON_PATH('override', 'fr'),
        translations: JSON_PATH('translations', 'fr'),
        keys: JSON_PATH('keys', 'fr'),
        legal: JSON_PATH('legal', 'fr'),
        forms: JSON_PATH('forms', 'fr'),
    },
    ur: {
        override: JSON_PATH('override', 'ur'),
        translations: JSON_PATH('translations', 'ur'),
        keys: JSON_PATH('keys', 'ur'),
        legal: JSON_PATH('legal', 'ur'),
        forms: JSON_PATH('forms', 'ur'),
    },
    tr: {
        override: JSON_PATH('override', 'tr'),
        translations: JSON_PATH('translations', 'tr'),
        keys: JSON_PATH('keys', 'tr'),
        legal: JSON_PATH('legal', 'tr'),
        forms: JSON_PATH('forms', 'tr'),
    },
}

i18n.use(initReactI18next).init(
    {
        lng: 'en',
        resources,
        fallbackLng: isTranslationModeEnabled ? false : 'en',
        debug: false,
        ns: ['override', 'legal', 'forms', 'keys', 'translations'],
        defaultNS: 'override',
        fallbackNS: ['legal', 'forms', 'keys', 'translations'],
        keySeparator: '.',
        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
        },
        react: {
            useSuspense: false,
            transEmptyNodeValue: '',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'hr'],
        },
        whitelist: languages,
    },
    (err, t) => {
        if (!IS_PRODUCTION && err) {
            return console.table('language key error', err)
        }
    }
)

export default i18n
